<template>
  <div class="">
    <h3>热门机型</h3>
    <div class="">
      <div
        v-for="(item, index) in showHotProductList"
        :key="index"
        class="product_item_box"
        @click="productItemClick(item)"
      >
        <img :src="item.listSrc" alt="" />
        <p>{{ item.id }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { productList, hotProductList } from "@/utils/const.js";
export default {
  name: "HotProduct",
  data() {
    return {
      data: []
    };
  },
  computed: {
    showHotProductList() {
      return hotProductList.map(item => {
        return productList.find(productItem => productItem.id === item);
      });
    }
  },
  methods: {
    productItemClick(item) {
      this.$router.push("/product/detail?id=" + item.id);
    }
  }
};
</script>

<style scoped lang="scss">
h3 {
  width: 204px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #f7f7f7;
  line-height: 44px;
  padding-left: 18px;
}
.product_item_box {
  width: 200px;
  height: 200px;
  background: #ffffff;
  border: 2px solid #f7f7f7;
  position: relative;
  box-sizing: content-box;
  border-top: none;
  p {
    width: 204px;
    height: 38px;
    background: #ebebeb;
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    color: #323232;
    position: absolute;
    bottom: -2px;
    left: -2px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.product_item_box:hover {
  box-shadow: 0px 4px 47px 7px rgba(165, 165, 165, 0.36);
  cursor: pointer;
  p {
    background: #fbe74e;
    font-weight: 600;
  }
}
</style>
